import React, { Fragment, useEffect, useState } from "react";
import M from "materialize-css";

import { useAuth } from "../../../Context/Context";

const OfertaRelampago = ({ profesoresCursos }) => {
  const [pickerInfoFechaInicio, setPickerInfoFechaInicio] = useState("");
  const [pickerInfoFechaFin, setPickerInfoFechaFin] = useState("");
  const [pickerOfertaFechaInicio, setPickerOfertaFechaInicio] = useState("");
  const [pickerOfertaFechaFin, setPickerOfertaFechaFin] = useState("");

  const { setOfertaRelampago, ofertaRelampago } = useAuth();

  useEffect(() => {
    setOfertaRelampago({
      ...ofertaRelampago,
      pickerInfoFechaInicio,
      pickerInfoFechaFin,
      pickerOfertaFechaInicio,
      pickerOfertaFechaFin,
    });
  }, [
    pickerInfoFechaInicio,
    pickerInfoFechaFin,
    pickerOfertaFechaInicio,
    pickerOfertaFechaFin,
  ]);

  const activar = () => {
    var fecha = document.querySelectorAll(".datepicker");
    M.Datepicker.init(fecha[0], {
      onSelect: (fecha) => {
        setPickerInfoFechaInicio(fecha);
      },
      // defaultDate: new Date();
    });
    M.Datepicker.init(fecha[1], {
      onSelect: (fecha) => {
        let fechaFin = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate(),
          17,
          59,
          0
        );

        setPickerInfoFechaFin(fechaFin);
      },
    });
    M.Datepicker.init(fecha[2], {
      onSelect: (fecha) => {
        setPickerOfertaFechaInicio(fecha);
      },
      // defaultDate: new Date();
    });
    M.Datepicker.init(fecha[3], {
      onSelect: (fecha) => {
        let fechaFin = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate(),
          17,
          59,
          0
        );

        setPickerOfertaFechaFin(fechaFin);
      },
    });

    let elems_select = document.querySelectorAll("select");
    M.FormSelect.init(elems_select);
  };

  const leerFechaRelampago = (e) => {
    e.preventDefault();
    let fechaRelampagoCopia = { ...ofertaRelampago.fecha_relampago };
    fechaRelampagoCopia[e.target.name] = e.target.value;
    setOfertaRelampago({
      ...ofertaRelampago,
      fecha_relampago: fechaRelampagoCopia,
    });
  };

  const leerPago = (e) => {
    let copiaPago = { ...ofertaRelampago.data_pago };
    copiaPago[e.target.name] = e.target.value;

    setOfertaRelampago({
      ...ofertaRelampago,
      data_pago: copiaPago,
    });
  };

  return (
    <Fragment>
      <p>Oferta relampago</p>
      <div className="switch">
        <label className="active">
          No
          <input
            onChange={() => {
              setOfertaRelampago({
                ...ofertaRelampago,
                oferta_relampago: !ofertaRelampago.oferta_relampago,
              });
              setTimeout(() => {
                activar();
              }, 100);
            }}
            type="checkbox"
          />
          <span className="lever"></span>
          Si
        </label>
      </div>

      {ofertaRelampago.oferta_relampago && (
        <div>
          <div>
            <div className="input-field">
              <input
                onChange={leerPago}
                defaultValue={ofertaRelampago.data_pago.descuento_relampago}
                id="descuento_relampago"
                name="descuento_relampago"
                type="text"
                className="validate"
              />
              <label className="active" for="descuento_relampago">
                Descuento
              </label>
            </div>
            <p>Comienzo</p>
            <div className="input-field">
              <input
                id="fecha_inicio"
                name="fecha_inicio"
                type="text"
                className="datepicker"
              />
              <label className="active" for="fecha_inicio">
                Fecha
              </label>
            </div>
            <p>Fin</p>
            <div className="input-field">
              <input
                id="fecha_fin"
                name="fecha_fin"
                type="text"
                className="datepicker"
              />
              <label className="active" for="fecha_fin">
                Fecha
              </label>
            </div>
          </div>

          <div>
            <p>Fecha de oferta relampago</p>
            <div>
              <div className="input-field">
                <input
                  onChange={leerFechaRelampago}
                  defaultValue={ofertaRelampago.fecha_relampago.dias}
                  id="dias_relampago"
                  name="dias"
                  type="text"
                  className="validate"
                  required
                />
                <label className="active" for="dias_relampago">
                  Días
                </label>
              </div>
              <div className="input-field">
                <input
                  onChange={leerFechaRelampago}
                  defaultValue={ofertaRelampago.fecha_relampago.horario}
                  id="horario_relampago"
                  name="horario"
                  type="text"
                  className="validate"
                  required
                />
                <label className="active" for="horario_relampago">
                  Horario
                </label>
              </div>
              <div>
                <p>Fecha: {}</p>
                <input
                  type="text"
                  placeholder="Inicio"
                  name="fecha_inicio"
                  className="datepicker"
                  required
                />
                <input
                  type="text"
                  placeholder="Fin"
                  name="fecha_fin"
                  className="datepicker"
                  required
                />
              </div>
              <div className="input-field">
                <input
                  onChange={leerFechaRelampago}
                  defaultValue={ofertaRelampago.fecha_relampago.sesiones}
                  id="sesiones_relampago"
                  name="sesiones"
                  type="text"
                  className="validate"
                  required
                />
                <label className="active" for="sesiones_relampago">
                  Numero de sesiones
                </label>
              </div>
              <div className="input-field">
                <input
                  onChange={leerFechaRelampago}
                  defaultValue={ofertaRelampago.fecha_relampago.duracion}
                  id="duracion_relampago"
                  name="duracion"
                  type="text"
                  className="validate"
                  required
                />
                <label className="active" for="duracion_relampago">
                  Total de horas
                </label>
              </div>
              <div className="input-field">
                <select
                  name="tutor"
                  id="tutor_relampago"
                  onChange={leerFechaRelampago}
                  required
                >
                  <option value="0">Selecciona un profesor</option>
                  {profesoresCursos.map((profesor) => (
                    <option value={profesor._id}>{profesor.nombre}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default OfertaRelampago;
